<template lang="pug">
transition(name="el-zoom-in-top")
  .content-wrapper
    <!-- Main content -->
    section.content
      .box.citic-box
        el-page-header(@back="goBack" content="销售线索管理列表")
        el-button.upload(type="primary" @click="handleDownUnloadAll") 下载
        el-table(:data="unloadDetailList" style="width: 100%;margin-bottom: 20px;margin-top:20px")
          el-table-column(prop="factory_qc_name" label="厂商全称" width="200")
          el-table-column(prop="factory_short_name" label="厂商简称")
          el-table-column(prop="realname", label="姓名")
          el-table-column(prop="company", label="公司" width="200")
          el-table-column(prop="position" label="职位")
          el-table-column(prop="phone" label="手机号")
          el-table-column(prop="user_email" label="邮箱")
          el-table-column(prop="operationtime" label="报名时间" width="150") 
          el-table-column(prop="operationtime" label="支付时间" width="150") 
          el-table-column(label="删除垃圾信息" width="150") 
            template(slot-scope="scope")
              el-button(@click="changeStatus(scope.row)" type="danger") 删除
        .table-list__footer
          el-pagination(
            @current-change="handlePageChange",
            :current-page="currentPage",
            :page-size="page_size",
            layout="total, prev, pager, next, jumper",
            :total="total"
          )
</template>

<script>
import axios from 'axios'
export default {
  props: ['id'],
  data () {
    return {
      currentPage: 1,
      total: 0,
      unloadDetailList: null
    }
  },
  methods: {
    // 删除垃圾信息
    changeStatus (scope) {
      console.log(scope, scope)
      let url = this.$config.API.sales.deleteByAccount
      // this.loading = true
      let data = {
        leads_ids: scope.explain_id
      }
      axios.post(url, data).then(res => {
        // this.activeName === '2' ? 已确认 : 待确认
        // this.activeName = !this.activeName
        // console.log(this.activeName)
        this.loading = false
        this.$message.success('删除成功')
        this.getListUnloadDetail()
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    handleClick () {
      //
    },
    // 获取文件名
    getFileName () {
      let str = '选型宝企业账号所带来的销售线索'
      let date = new Date()
      return `${str}_${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}.xls`
    },
    // 获取未下载
    handleDownUnloadAll () {
      let fileName = this.getFileName()
      let data = {
        enterprise_account_id: this.id
      }
      let url = this.$config.API.sales.downloadNewByAccount + `?enterprise_account_id=${data.enterprise_account_id}`
      axios.post(url, data, {
        responseType: 'blob'
      }).then(res => {
        if (res.status === 200) {
          const url = URL.createObjectURL(new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 返回上一页
    goBack () {
      this.$router.go(-1)
    },
    handlePageChange (page) {
      this.currentPage = page
      this.getListUnloadDetail()
    },
    // 未下载详情
    async getListUnloadDetail () {
      let url = await this.$config.API.sales.listNewByAccount
      axios.get(url, {
        params: {
          page: this.currentPage,
          // pageSize: 10,
          enterprise_account_id: this.id
        }
      }).then(res => {
        this.unloadDetailList = res.data.data.applyexplainList
        this.total = res.data.TOTAL_NUM
        console.log('unloadDetailList', this.unloadDetailList)
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    }
  },
  mounted () {
    this.getListUnloadDetail()
  }
}
</script>
<style lang="scss">
.upload{
  position: absolute;
  top: 15px;
  right: 20px;
}
</style>


// WEBPACK FOOTER //
// unload.vue?ac10636e